module.exports = __webpack_public_path__ + "assets/img/banner.48228d94.jpg";